import * as tslib_1 from "tslib";
export function isType(action, actionCreator) {
  return action.type === actionCreator.type;
}

var simpleCb = function simpleCb(data) {
  return {
    payload: data
  };
};

function getActionKey(prefix, key) {
  return prefix + "/" + key;
}

function getSubActionKey(key, subaction) {
  return key + "_" + subaction;
}

export function createActionCreators(actionsPrefix) {
  function createAction(key, payloadMapper) {
    var type = getActionKey(actionsPrefix, key);

    var action = function action() {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return tslib_1.__assign({}, (payloadMapper || simpleCb).apply(void 0, tslib_1.__spread(args)), {
        type: type
      });
    };

    action.type = type;
    return action;
  }

  function createAsyncAction(key, cb) {
    var action = createAction(key, cb);
    action.fulfilled = createAction(getSubActionKey(key, 'FULFILLED'));
    action.rejected = createAction(getSubActionKey(key, 'REJECTED'));
    action.pending = createAction(getSubActionKey(key, 'PENDING'));
    return action;
  }

  function createSimpleAsyncAction(key, cb) {
    return createAsyncAction(key, function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      return {
        payload: cb.apply(void 0, tslib_1.__spread(args))
      };
    });
  }

  return {
    createAction: createAction,
    createAsyncAction: createAsyncAction,
    createSimpleAsyncAction: createSimpleAsyncAction
  };
}